import { assert } from "../asserts/index.ts";
import type { DesignerNodeData, NodeSlotPath } from "../schemas/index.ts";

type Node = Pick<DesignerNodeData, "id" | "typeId" | "childNodes">;

export const buildSlotPathByIdLookup = (rootNode: Node): Map<number, NodeSlotPath> => {
  const lookup = new Map<number, NodeSlotPath>();
  assert(rootNode);

  const populateLookup = ({ id, typeId, childNodes }: Node, path: NodeSlotPath) => {
    lookup.set(id, path);

    for (const [name, childOrChildren] of Object.entries(childNodes)) {
      if (Array.isArray(childOrChildren)) {
        let index = 0;
        for (const child of childOrChildren) {
          const subPath: NodeSlotPath = [...path, { parent: [typeId, id], name, index }];
          populateLookup(child, subPath);
          index += 1;
        }
      } else if (childOrChildren) {
        const subPath: NodeSlotPath = [...path, { parent: [typeId, id], name }];
        populateLookup(childOrChildren, subPath);
      }
    }
  };

  populateLookup(rootNode, []);

  return lookup;
};
